import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { FORMIK_EMPTY_VALUE } from '../../../../../constants/validation'
import { useScreen } from '../../../../../hooks'
import { BuildingSelect } from '../../../../Building'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import {
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING,
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_FLAT,
} from '../../RequestWizardForm.constants'

import { getBuildingApiParams } from './BuildingFields.utils'

import * as styles from '../RequestWizardInitStageFormFields.module.css'

function BuildingField({
  apiParams,
  isFilledAddressDisabled,
  isLoading,
  required,
  onClear,
  ...restProps
}) {
  const { t } = useTranslation()

  const { setFieldValue, values } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  function handleClear() {
    onClear?.()
    setFieldValue(REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_FLAT, FORMIK_EMPTY_VALUE)
  }

  function handleChange() {
    onClear?.()
    setFieldValue(REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_FLAT, FORMIK_EMPTY_VALUE)
  }

  const buildingApiParams = { ...apiParams, ...getBuildingApiParams(values) }

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={BuildingSelect}
      apiParams={buildingApiParams}
      controlProps={{
        borderless: !isMobileScreenSize,
        className: isFilledAddressDisabled
          ? styles.disabledPointerEvents
          : undefined,
        contentProps: {
          inputProps: {
            placeholder: t('Wizard.BuildingPlaceholderKey'),
          },
        },
        indicatorsProps: isFilledAddressDisabled
          ? {
              ButtonArrow: null,
              ButtonClear: null,
            }
          : undefined,
      }}
      disabled={isLoading}
      fieldComponentProps={{
        disabled: isLoading,
        label: `${t('Wizard.BuildingLabelKey')}:`,
        required,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING}
      onChange={handleChange}
      onClear={handleClear}
    />
  )
}

export default BuildingField
